import { Col, Row, Spinner2 } from 'components';
import { Api } from 'lib';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import MrrShell from './MrrShell';

const Mrr = () => {
  const { t, i18n } = useTranslation();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [viewMode, setViewMode] = useState('country');
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const years = Array.from({ length: 7 }, (_, idx) => now.getFullYear() - idx);
  const months = Array.from({ length: 12 }, (_, idx) => ({
    value: idx + 1,
    label: new Date(now.getFullYear(), idx, 1).toLocaleString(i18n.language || 'en', {
      month: 'short'
    }),
    disabled: selectedYear === currentYear && idx + 1 > currentMonth
  }));

  useEffect(() => {
    fetchMrr();
  }, [selectedYear, selectedMonth]);

  async function fetchMrr() {
    setLoading(true);
    const params = new URLSearchParams();
    if (selectedYear) params.set('year', String(selectedYear));
    if (selectedMonth) params.set('month', String(selectedMonth));
    const res = await Api.get(
      `/admin/subscriptionPlans/overview${params.toString() ? `?${params.toString()}` : ''}`
    );
    if (res?.data) {
      setData(res.data?.mrr || null);
    }
    setLoading(false);
  }

  if (loading) {
    return (
      <Col wid="100%" marg="80px 0" centerAll noFlex>
        <Spinner2 />
      </Col>
    );
  }

  return (
    <Col start noFlex wid="100%">
      <Row start gap="12px" pad="12px 24px" noFlex>
        <select
          className="h-10 min-w-[120px] rounded-lg border border-[#d7dee8] px-3 text-[13px] text-[#334155] bg-white"
          value={selectedYear}
          onChange={(e) => {
            const newYear = Number(e.target.value);
            setSelectedYear(newYear);
            if (newYear === currentYear && selectedMonth > currentMonth) {
              setSelectedMonth(currentMonth);
            }
          }}
        >
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>

        <select
          className="h-10 min-w-[120px] rounded-lg border border-[#d7dee8] px-3 text-[13px] text-[#334155] bg-white"
          value={selectedMonth}
          onChange={(e) => setSelectedMonth(Number(e.target.value))}
        >
          {months.map((month) => (
            <option key={month.value} value={month.value} disabled={month.disabled}>
              {month.label}
            </option>
          ))}
        </select>

        <div className="inline-flex items-center rounded-lg border border-[#D7DEE8] bg-[#F1F5F9] p-1">
          <button
            type="button"
            onClick={() => setViewMode('country')}
            aria-pressed={viewMode === 'country'}
            className={`px-3 py-1.5 rounded-md text-[12px] font-semibold transition-all duration-150 ${
              viewMode === 'country'
                ? 'bg-[#334155] text-white shadow-[0_2px_6px_rgba(15,23,42,0.28)]'
                : 'text-[#64748B] hover:text-[#334155] hover:bg-white/70'
            }`}
          >
            {t('subscriptions.admin.overview.mrr.byCountry')}
          </button>
          <button
            type="button"
            onClick={() => setViewMode('plan')}
            aria-pressed={viewMode === 'plan'}
            className={`px-3 py-1.5 rounded-md text-[12px] font-semibold transition-all duration-150 ${
              viewMode === 'plan'
                ? 'bg-[#334155] text-white shadow-[0_2px_6px_rgba(15,23,42,0.28)]'
                : 'text-[#64748B] hover:text-[#334155] hover:bg-white/70'
            }`}
          >
            {t('subscriptions.admin.overview.mrr.byPlan')}
          </button>
          <button
            type="button"
            onClick={() => setViewMode('team')}
            aria-pressed={viewMode === 'team'}
            className={`px-3 py-1.5 rounded-md text-[12px] font-semibold transition-all duration-150 ${
              viewMode === 'team'
                ? 'bg-[#334155] text-white shadow-[0_2px_6px_rgba(15,23,42,0.28)]'
                : 'text-[#64748B] hover:text-[#334155] hover:bg-white/70'
            }`}
          >
            {t('subscriptions.admin.overview.mrr.byTeam')}
          </button>
        </div>
      </Row>

      <Col
        start
        wid="100%"
        style={{ overflow: 'auto', maxHeight: 'calc(100vh - 170px)' }}
      >
        <MrrShell data={data} viewMode={viewMode} />
      </Col>
    </Col>
  );
};

export default Mrr;
